import { Box, Paper, Typography } from '@mui/material'
import phone from '../../assets/svg/bxs_phone-call.svg'
import email from '../../assets/svg/ic_sharp-email.svg'
import location from '../../assets/svg/carbon_location-filled.svg'
import {
  Instagram as InstagramIcon,
  FacebookOutlined as FacebookOutlinedIcon,
  X as XIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";

import { TextField, Button, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import SupabaseService from '../../utils/supabaseClient';
import { sendmail } from '../../utils/commonFunction';
import { FunctionContext } from '../../context/FunctionProvider';
import { useContext } from 'react';


const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
    .required('Phone number is required'),
});

const initialValues = {
  name: '',
  email: '',
  phone: '',
};
export default function ContactUsPage() {
  const { customBreakpoints } = useContext(FunctionContext);
  const handleSubmit = async (values, { resetForm }) => {
    sendmail(values).then(() => {
      resetForm()
    })

  };
  const mediaFlag = customBreakpoints.isMobile || customBreakpoints.isDeviceDown

  return (
    <Box display={"flex"} justifyContent={mediaFlag?"center":"flex-start"} alignItems={"center"} width={"100%"} height={"90dvh"}>
      <Box marginLeft={"25dvw"} display={mediaFlag ? "none" : "flex"} flexDirection={"column"} gap={"6dvh"} width={"24dvw"} height={"70dvh"} borderRadius={"10px"} padding={"2dvw"} sx={{ background: "#EF9E11", color: "white" }}>
        <Typography variant="h5" fontFamily={"Poppins"} fontStyle={"SemiBold"}>Contact Information</Typography>
        <Typography variant='p' display={"flex"} alignItems={"center"} gap={"15px"}><img src={phone}></img> +9751813050 </Typography>
        <Typography variant='p' display={"flex"} alignItems={"center"} gap={"15px"}><img src={email}></img> ram1711sai@gmail.com </Typography>

        <Typography variant='p' display={"flex"} alignItems={"center"} gap={"15px"}><img src={location}></img> Chennai,Tamilnadu </Typography>
      </Box>
      <Paper elevation={3} sx={{
        width:mediaFlag?"80dvw": "35dvw", height: "55dvh", position:mediaFlag?"static": "absolute", left:mediaFlag?"0": "50dvw", zIndex: 1, borderRadius: "10px", padding: "20px"
      }} >
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
              <Box display={"flex"} flexDirection={"column"} gap={"25px"} sx={{ maxWidth: 500, margin: 'auto', mt: 5 }}>
                <Typography variant='h5' color=' #000000' fontFamily={"Poppins"} >Contact Us!</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Phone Number"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button sx={{ borderRadius: "50px", background: "#3276FF" }} type="submit" variant="contained" color="primary" fullWidth>
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  )
}
